import { render, staticRenderFns } from "./distribute-rule.vue?vue&type=template&id=1aef8e2c&scoped=true"
import script from "./distribute-rule.vue?vue&type=script&lang=ts"
export * from "./distribute-rule.vue?vue&type=script&lang=ts"
import style0 from "./distribute-rule.vue?vue&type=style&index=0&id=1aef8e2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef8e2c",
  null
  
)

export default component.exports